import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { Item  } from '@providers/asset/index';

@Component({
  selector: 'page-pic',
  templateUrl: 'page.html'
})
export class PicPage {

  List: any = [];
  pilihModal=0;
  base_url='';

  constructor(
    public navCtrl: NavController,
    public itemApi: Item,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.pilihModal = navParams.get('pilih');

    this.List = itemApi.listPIC();
    this.base_url = itemApi.base_url;
  }

  ionViewDidEnter() {

  }

  doRefresh(refresher) {
    refresher.complete();

  }

  /* getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { };
    this.masterApi.getCondition(params).subscribe((resp:any) => {
      this.List = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  } */

  select(item){

  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/pic/page.ts